import { IExportStrategy } from "./exportOrders/types";
import { InternalExportStrategy } from "./exportOrders/InternalExportStrategy";
import { MarketplaceExportStrategy } from "./exportOrders/MarketplaceExportStrategy";
import { MerchantExportStrategy } from "./exportOrders/MerchantExportStrategy";
import { EcommerceExportStrategy } from "./exportOrders/EcommerceExportStrategy";

type EntityType = "internal" | "marketplace" | "merchant" | "ecommerce";

const strategyMap: Record<EntityType, new (marketplaceId?: string) => IExportStrategy> = {
  internal: InternalExportStrategy,
  marketplace: MarketplaceExportStrategy,
  merchant: MerchantExportStrategy,
  ecommerce: EcommerceExportStrategy,
};

export const createOrdersExportStrategy = (
  entity: EntityType,
  marketplaceId?: string
): IExportStrategy => {
  const StrategyClass = strategyMap[entity] || MarketplaceExportStrategy;
  return new StrategyClass(marketplaceId);
};
